import { use } from 'react'
import { loadCatalog } from './load'
import type { Catalog } from './types'

/** Suspends until the catalog is loaded; load errors reach the route error boundary. */
export function useCatalog(): Catalog {
  return use(loadCatalog())
}
